import { CustomerDetails } from './customerDetails';
import { ExploreOptionsFormValues, ExploreYourOptionsPot } from './exploreYourOptions';

export enum FormKeys {
    CUSTOMER_DETAILS = 'customerDetails',
    TARGET_INCOME = 'targetIncome',
    STATE_PENSION = 'statePension',
    FINAL_SALARY = 'finalSalary',
    OTHER_INCOME = 'otherIncome',
    OTHER_PENSION_POTS = 'otherPensionPots',
    PROJECTED_POT_VALUE = 'projectedPotValue',
    EXPLORE_OPTIONS = 'exploreOptions',
    CALCULATIONS = 'calculations',
    LANDING_POSITION = 'landingPosition',
    POTS = 'pots',
}

export type TargetIncomeFormValues = {
    targetType: string;
    amount: number;
    budget: {
        housing: number;
        maintenance: number;
        groceries: number;
        travel: number;
        holidays: number;
        clothing: number;
        helping: number;
        other: number;
    };
};

export type StatePensionFormValues = {
    isFullAmount: string;
    amount: number;
};

export type FinalSalaryFormValues = {
    finalSalaryInd: string;
    amount?: number;
    payableAge?: number;
};

export type OtherIncomeFormValues = {
    otherIncomeInd: string;
    amount?: number;
    startAge?: number;
};

export type OtherPensionPotsFormValues = {
    otherPensionPotsInd: string;
    pensionAmount?: number;
    grossContributions?: number;
};

export type RetirementCalculations = {
    additionalContributions: number;
    annuityCost: number;
    annuityIncomePerYear: number;
    annuityIncomePerYearMax: number;
    annuityIncomePerYearMin: number;
    drawdownEndAge: number;
    drawdownIncomePerYear: number;
    drawdownIncomePerYearMax: number;
    drawdownPotUsed: number;
    potValue: number;
    pots: ExploreYourOptionsPot[];
    projectedMaximumTaxFreeCash?: number;
    projectedPotValue: number;
    remainingPotValue: number;
    retirementAge: number;
    tfcAmount: number;
    tfcPercentage: number;
};

export type IncomePots = {
    defaultPots: ExploreYourOptionsPot[];
    explorePots: ExploreYourOptionsPot[];
};

export type FormDataType = {
    [FormKeys.CUSTOMER_DETAILS]: CustomerDetails;
    [FormKeys.TARGET_INCOME]: TargetIncomeFormValues;
    [FormKeys.STATE_PENSION]: StatePensionFormValues;
    [FormKeys.FINAL_SALARY]: FinalSalaryFormValues;
    [FormKeys.OTHER_INCOME]: OtherIncomeFormValues;
    [FormKeys.OTHER_PENSION_POTS]: OtherPensionPotsFormValues;
    [FormKeys.PROJECTED_POT_VALUE]: number;
    [FormKeys.LANDING_POSITION]: RetirementCalculations;
    [FormKeys.EXPLORE_OPTIONS]: ExploreOptionsFormValues;
    [FormKeys.CALCULATIONS]: RetirementCalculations;
    [FormKeys.POTS]: IncomePots;
};

export type FormDataContextValue = FormDataType & {
    updateFormDataState: (props: Partial<FormDataType>) => void;
};

export type CustomerDetailsSchema = Pick<FormDataType, FormKeys.CUSTOMER_DETAILS>;
export type TargetIncomeSchema = Pick<FormDataType, FormKeys.TARGET_INCOME>;
export type StatePensionSchema = Pick<FormDataType, FormKeys.STATE_PENSION>;
export type FinalSalarySchema = Pick<FormDataType, FormKeys.FINAL_SALARY>;
export type OtherIncomeSchema = Pick<FormDataType, FormKeys.OTHER_INCOME>;
export type OtherPensionPotsSchema = Pick<FormDataType, FormKeys.OTHER_PENSION_POTS>;
export type ExploreOptionsSchema = Pick<FormDataType, FormKeys.EXPLORE_OPTIONS>;
